export default {"src":"/_next/static/media/section-break-mini.1e86fbe9.svg","height":24,"width":24};